import React, { useEffect, useState } from 'react'
import { GetById_ObjectInstance_Api } from '../../API/ObjectInstanceApi';
import { Button, Col, Form, Row, } from 'antd';
import { GetAll_Field_Api } from '../../API/FieldApi';
import { GetAll_Object_Field_Value_Api } from '../../API/ObjectFieldValueApi';
import { EditObjectFieldValueDetailsComponent } from './EditObjectFieldValueDetailsComponent';
import { CloseOutlined, DoubleRightOutlined, RollbackOutlined } from '@ant-design/icons';
// =================================================================
export const EditObjectFieldValueComponent = ({ objectTypeId, objectInstanceId, setLoading, showMessage, onCompleteEdit }) => {
    // =================================================================
    const [objectInstance, setObjectInstance] = useState();
    const [fields, setFields] = useState();
    const [fieldValues, setFieldValues] = useState();
    const [form] = Form.useForm();
    // =================================================================
    useEffect(() => {
        setObjectInstance(null);
        loadObjectInstance();
        loadFields();
        loadFieldValues();
    }, [objectInstanceId]);
    // =================================================================
    const loadObjectInstance = async () => {
        setLoading(true);
        try {
            const data = await GetById_ObjectInstance_Api(objectInstanceId);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setObjectInstance(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const loadFields = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Field_Api({ objectTypeId: objectTypeId });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setFields(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const loadFieldValues = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Object_Field_Value_Api(objectInstanceId);
            form.setFieldsValue(data.messageData.data[0])
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setFieldValues(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    return (
        <>
            {objectInstance ? (
                <>
                    <div className='sectionTitle'>
                        <h2 >
                            خاصیت های {objectInstance.title}
                        </h2>
                    </div>
                    <div className='container'>

                        {fields?.map((field) =>
                            <>
                                <div className="valueRow" key={field.id}>
                                    <EditObjectFieldValueDetailsComponent
                                        setLoading={setLoading}
                                        showMessage={showMessage}

                                        objectInstanceValues={{
                                            "fieldId": '' + field.id,
                                            "fieldTitle": field.title,
                                            "value": '' + fieldValues?.filter(fv => fv.fieldId === field.id)[0]?.value,
                                            "id": '' + fieldValues?.filter(fv => fv.fieldId === field.id)[0]?.id,
                                            "objectInstanceId": '' + objectInstance.id,
                                            "objectInstanceTitle": objectInstance.title,

                                        }}

                                    />
                                </div>
                            </>
                        )}
                    </div>

                    <Row className='sectionFooter'>
                        <Col xs={16} sm={16} md={16} lg={20} xl={20} >
                        </Col>
                        <Col xs={8} sm={8} md={8} lg={4} xl={4} >
                            <Button
                                className='btn-secondary'
                                style={{ width: '100%' }}
                                onClick={() => onCompleteEdit()}>
                                <DoubleRightOutlined />
                                بازگشت </Button>
                        </Col>
                    </Row>
                </>
            ) : (<>
            </>)
            }

        </>
    )

}
